<template>
  <div class="drpz">
    <div class="drpzLeft">
      <div class="sjypzLeft leftItem">
        <div class="leftItemTitle">
          <myTitleName titleName="数据源配置">
            <template slot="titleRight">
              <img class="sjypzAdd" @click="isShowSjypzAdd=true" src="@/assets/images/sys/drpz/add.png" alt="">
            </template>
          </myTitleName>
        </div>
        <div class="leftItemList">
          <div class="leftItemListItem" v-for="(item,index) in sjyPzList" :key="index">
            <div class="leftItemListItemLeft">
              <img src="@/assets/images/sys/drpz/sjypz-icon.png" alt="">
              <span>{{item.name}}</span>
            </div>
            <div class="leftItemListItemRight" @click="isShowSjypzAdd=true">编辑</div>
          </div>
        </div>
      </div>
      <div class="sjkBLeft leftItem">
        <div class="leftItemTitle">
          <myTitleName titleName="数据库表">
            <!-- <template slot="titleRight">
              <img class="sjypzAdd" src="@/assets/images/sys/drpz/add.png" alt="">
            </template> -->
          </myTitleName>
        </div>
        <div class="leftItemList">
          <div class="leftItemListItem" v-for="(item,index) in sjkBList" :key="index">
            <div class="leftItemListItemLeft">
              <img src="@/assets/images/sys/drpz/sjypz-icon.png" alt="">
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="drpzRight">
      <myTableSearch ref="myTableSearchRef" :isOperate="true" :operateWidth="120" 
        titleName='导入模版'
        :queryFn="getList" 
        :formData="formData" 
        :tableLabel="tableLabel"
        @recombinationData="recombinationData"
      >
        <template slot="tool">
          <div class="flex flex-x">
            <!-- <p class="fillBtn" @click="isDrawer=true">新增数据 <img src="@/assets/add.png" alt=""></p> -->
            <p class="fillBtn" @click="isShowMbdr=true">模版导入</p>
            <!-- <p class="fillBtn ml-1" @click="isShowCjmb=true">创建模版</p> -->
          </div>
        </template>
        <template slot="operate" slot-scope="scope">
          <el-button type="text" size="small" style="color:#F29D5A">测试</el-button>
          <el-button type="text" size="small" style="color:#0C7BF2">编辑</el-button>
          <el-button type="text" size="small" style="color:#9797FC">预览</el-button>
          <el-button type="text" size="small" style="color:#F14A3F">删除</el-button>
        </template>
      </myTableSearch>
    </div>

    <!-- 数据源配置新增 -->
    <sjypzDialog v-if="isShowSjypzAdd" :isShowSjypzAdd="isShowSjypzAdd" @handleClose="isShowSjypzAdd=false"></sjypzDialog>

    <!-- 模板导入 -->
    <mbdrDialog v-if="isShowMbdr" :isShowMbdr="isShowMbdr" @handleClose="isShowMbdr=false"></mbdrDialog>
    
    <!-- 创建模版 -->
    <cjmbDialog v-if="isShowCjmb" :isShowCjmb="isShowCjmb" @handleClose="isShowCjmb=false"></cjmbDialog>
  </div>
</template>

<script>
import sjypzDialog from './components/sjypzDialog.vue'
import mbdrDialog from './components/mbdrDialog.vue'
import cjmbDialog from './components/cjmbDialog/index.vue'
export default {
  components:{
    sjypzDialog,
    mbdrDialog,
    cjmbDialog,
  },
  data() {
    return {
      isShowCjmb:false,//创建模板
      isShowMbdr:false,//模板导入
      isShowSjypzAdd:false,//数据源配置
      sjyPzList:[
        {
          name:'lsshzl_business',
        },
        {
          name:'lsshzl_sys',
        },
        {
          name:'lsshzl_business',
        },
        {
          name:'lsshzl_sys',
        },
        {
          name:'lsshzl_business',
        },
        {
          name:'lsshzl_sys',
        },
        {
          name:'lsshzl_sys',
        },
        {
          name:'lsshzl_sys',
        },
      ],
      sjkBList:[
        {
          name:'syrk_jbxxb',
        },
        {
          name:'syrk_jzdxxb',
        },
        {
          name:'syrk_jbxxb',
        },
        {
          name:'syrk_jzdxxb',
        },
        {
          name:'syrk_jbxxb',
        },
        {
          name:'syrk_jzdxxb',
        },
        {
          name:'syrk_jbxxb',
        },
        {
          name:'syrk_jzdxxb',
        },
        {
          name:'syrk_jbxxb',
        },
        {
          name:'syrk_jzdxxb',
        },
      ],
      formData: [
        {
          label: '标题',
          type: 'input',
          key: 'bt',
        },
        {
          label: '表名',
          type: 'input',
          key: 'bm',
        },
        {
          label: '发布状态',
          type: 'select',
          key: 'fbzt',
          data: [],
          requestType:'dict',
          dictName:'syrk_xb',
        },
      ],
      tableLabel: [
        {
          prop: 'bt',
          label: '标题',
        },
        {
          prop: 'bm',
          label: '表名',
        },
        {
          prop: 'glb',
          label: '关联表',
        },
        {
          prop: 'mbwj',
          label: '模版文件',
        },
        {
          prop: 'fbzt',
          label: '发布状态',
        },
      ],
    }
  },
  mounted() {
        
  },
  methods: {
    getList(e){
      return (e)=>{e}
    },
     //格式化搜索字段
    recombinationData(param,callback){
      callback({...param})
    },
  },
}
</script>

<style lang="scss" scoped>
.drpz{
  width: 100%;
  height: 100%;
  display: flex;
  .leftItem{
    padding: 12px;
    border-radius: 5px;
    background: #ffffff;
    .leftItemTitle{
      padding-bottom: 12px;
      border-bottom: 1px solid #d1d5dc;
    }
    .leftItemList{
      padding: 9px 8px;
      height: calc(100% - 24px);
      overflow: auto;
      .leftItemListItem{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 18px;
        &:first-child{
          margin-top: 0px;
        }
        .leftItemListItemLeft{
          display: flex;
          align-items: center;
          >img{
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }
          >span{
            color: #51a6a6;
            font-weight: 500;
            font-size: 14px;
          }
        }
        .leftItemListItemRight{
          cursor: pointer;
          color: #0c7bf2;
          font-weight: 500;
          font-size: 14px;
        }
      }
    }
  }
  .drpzLeft{
    min-width: 312px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .sjypzLeft{
      height: 40%;
      .sjypzAdd{
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
    }
    .sjkBLeft{
      height: calc(60% - 16px);
      margin-top: 16px;
    }
  }
  .drpzRight{
    flex: 1;
    margin-left: 16px;
  }
}
</style>